const CodeType = {
    PRODUCT_INSTANCE: 'PRODUCT_INSTANCE',
    STOCK_LOCATION: 'STOCK_LOCATION'
};

export {CodeType};
